import { SupplierNotificationWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: SupplierNotificationWebService.Configuration
});

export default config;
